export default {
  REQUIRED_FIELD: "Field is required",
  REQUIRED_POSITIVE_NUMBER: "Please enter a positive number",
  PERCENTAGE_MAX_100: "Percentage must be less than or equal to 100",
};
